/**
 * Call after user opts into analytics and before gtag/js + gtag('config').
 * Keeps ad-related consent denied unless you run ads that need them.
 */
export function pushGoogleConsentGrantedForAnalytics(gtag: (...args: unknown[]) => void): void {
  gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}
